import { Link } from "react-router-dom";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-semibold text-foreground-950 whitespace-nowrap" style={{ fontFamily: "var(--font-heading)" }}>
                蘑菇视频
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              蘑菇视频 — 专业视频播放器APP，支持91视频、91在线视频等平台。提供安卓、苹果、iPad版免费下载，高清流畅不卡顿。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              快速链接
            </h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">首页</Link>
              <Link to="/category/hot" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">分类浏览</Link>
              <Link to="/articles" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">文章资讯</Link>
              <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              下载版本
            </h4>
            <div className="flex flex-col gap-2.5">
              <a href="#download" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">安卓版下载</a>
              <a href="#download" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">苹果iOS版下载</a>
              <a href="#download" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">iPad版下载</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              联系我们
            </h4>
            <div className="flex flex-col gap-2.5 text-sm text-foreground-600">
              <span>邮箱：support@moguvideo.com</span>
              <span>客服QQ：800123456</span>
              <span>工作时间：9:00 - 21:00</span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} 蘑菇视频 MoguVideo. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <span className="cursor-pointer hover:text-primary-500 transition-colors">隐私政策</span>
            <span className="cursor-pointer hover:text-primary-500 transition-colors">用户协议</span>
            <span className="cursor-pointer hover:text-primary-500 transition-colors">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}